import { GaugeNeedle } from "./GaugeNeedle";
export default GaugeNeedle;
